import React, { Component } from 'react';
import MyCarousel from '@/components/Carousel';
import { CAROUSEL_SETTINGS } from '&/constants/index';
import './index.scss';
export default class GraphicList extends Component {
    constructor(props) {
        super(props);
        this.state = { current: 0 };
    }
    afterChange = current => {
        const { pics } = this.props;
        if (current === 'left') {
            this.setState(state => {
                if (state.current > pics.length - 2) {
                    return { current: 0 };
                } else {
                    return { current: state.current + 1 };
                }
            });
        } else {
            this.setState(state => {
                if (state.current <= 0) {
                    return { current: pics.length - 1 };
                } else {
                    return { current: state.current - 1 };
                }
            });
        }
    };
    render() {
        const { pics } = this.props;
        const settings = {
            ...CAROUSEL_SETTINGS,
            onSwipe: this.afterChange,
        };
        return (
            <div className="carousel-warpper-graphic">
                <div className="pic-num">
                    <span className="current">{this.state.current + 1}</span>
                    <span className="total">/{pics.length}</span>
                </div>
                <MyCarousel
                    {...settings}
                    pics={pics}
                    imgWidth={80}
                    navGap={26}
                    dotsTotalWidth={640}
                    handleImageClick={this.props.handleImageClick}
                    selectNum={0}></MyCarousel>
            </div>
        );
    }
}
